/**
 * Parse optional decimal input from pump forms.
 * Empty / invalid values become null so clients do not send NaN.
 */
export function parseOptionalFloat(value) {
  if (value === '' || value == null) {
    return null;
  }
  const parsed = typeof value === 'number' ? value : parseFloat(String(value).trim().replace(',', '.'));
  return Number.isFinite(parsed) ? parsed : null;
}

/**
 * Build lift height / volume capacity fields for create/update payloads.
 * Intentionally omits legacy `capacity` (%) so older values stay untouched.
 */
export function buildPumpSpecificationFields({ lift_height, volume_capacity }) {
  return {
    lift_height: parseOptionalFloat(lift_height),
    volume_capacity: parseOptionalFloat(volume_capacity),
  };
}
